export const englisText = {
  immediately_available: "Immediately Available",
  legally_valid: "Legally valid for 10 years",
  energy_certificate: "Energy certificate according to GEG",
  consumption_certificate: "Consumption Certificate",
  need_certificate: "Need Certificate",
  step_1: "Step 1",
  step_2: "Step 2",
  step_3: "Step 3",
  step_4: "Step 4",
  step_5: "Step 5",
  step_6: "Step 6",
  step_7: "Step 7",
  step_8: "Step 8",
  building_info: "Building Info",
  heating_info: "Heating Info",
  heat_water_info: "Heat Water Info",
  vacancy_info: "Vacancy Info",
  property_info: "Property Info",
  property_address: "Property Address",
  certificate: "Certificate",
  billing_delivery_address: "Billing & Delivery Address",
  save_resume_later: "Save & Resume Later",
  next: `Next`,
  previous: "Previous",
  google_review: `Google review`,
  our_payment_methods: `Our Payment Methods`,
  energy_certificates: `Energy Certificates`,
  create_consumption_certificate: `create a consumption certificate`,
  create_needs_certificate: `create a needs certificate`,
  billing: "Billing and Delivery Address",
};

export const consumCertEngText = {
  building_data: "Building Data",
  provided_information: "Provided information",
  close: "Close",
  occasion: "Occasion",
  occasion_error: `This is required`,
  occasion_paragraph: `If you need the energy certificate for financing or a loan application, please select the reason for issue as "Other". Energy certificates with the reasons for issue as "New construction" or "Modernization" cannot be ordered according to Section 80 Sentences 1 and 2 GEG.`,
  postal_code: "Postal code",
  postal_code_error: `Invalid postal code`,
  building_type: `Building type`,
  building_type_error: `Building type is required`,
  building_type_paragraph: `For mixed-use buildings, we recommend a demand certificate as this provides more accurate results.`,
  year_of_construction: "Year of construction",
  year_of_construction_error: `Year must be between 1850 and`,
  number_of_apartments: `Number of apartments`,
  number_of_apartments_error: "required as a number.",
  number_of_apartments_paragraph: `Since energy certificates can only be issued for the entire building and not for individual apartments, information on all apartments in the building is required. Please count granny flats as separate residential units. For single-family homes, if there are no other apartments in the building, please select 1 residential unit.`,
  eMail: `E-Mail`,
  eMail_error: `Invalid email address`,
  eMail_para_1:
    "Please provide a valid email address so that we can contact you if we have any questions regarding your information.",
  eMail_para_2:
    "You will also receive the order confirmation and invoice via the email address you provided.",
  number_of_floors: "Number of floors",
  number_of_floors_error: "The number of floors is required as a number.",
  number_of_floors_paragraph: ``,
  floor_to_ceiling_height: "Floor to ceiling height (in meters)",
  floor_to_ceiling_height_error: "is required as a number.",
  floor_to_ceiling_height_paragraph: ``,
  is_there_heated_basement: `Is there a heated basement`,
  yes: "Yes",
  no: "No",
  Please_provide_proper_information: "Please provide proper information",
  heating_system_are_installed: `How many heating system are installed?`,
  energy_sources: `Energy sources`,
  energy_sources_error: "Energy source is required.",
  energy_sources_paragraph: "Please select your main energy source here",
  unit: "Unit",
  unit_error: `Unit ID is required.`,
  unit_para_1: `Please enter the correct consumption unit of the energy source/fuel.`,
  unit_para_2: `You can usually find this on your heating bill.`,
  name_of_provider_line: `If you do not know the primary energy factor of your energy provider, please tell us the name of your provider. `,
  name_of_provider_line1: `You can leave notes here.`,
  date: "Date",
  date_paragraph: `To apply for a consumption certificate, consumption values ​​from the last three years must be available - that is, the first billing period must be at least three years ago. Enter the month and year of the start of the first billing period here `,
  consumption_from_this: "Consumption for ",
  vacancy_from_this: `Vacancy rate from `,
  consumption_from_this_error:
    "Consumption field is invalid. It must be a non-negative number and should not contain 'e', '-', or '+'.",
  consumption_from_this_para_1:
    "Please enter the total energy consumption for each period here. A billing period is always one year long.",
  consumption_from_this_para_2:
    "For apartment buildings, you should state the total energy consumption of the entire building, as energy certificates always refer to the entire building.",
  consumption_from_this_para_3:
    "If it is a combined heat and power plant (CHP), please only state the amount of heat produced (without electricity).",
  included_heating_system: `Is hot water included in heating system?`,
  included_heating_system_paragraph: `Please indicate here whether the hot water energy consumption is already included in the consumption stated above or not. You can also specify the hot water energy consumption separately.`,
  consumption_is_unknown: `Consumption is unknown`,
  percentage_share_of_hot_water: `Percentage share of hot water`,
  percentage_share_of_hot_water_paragraph: `Enter the share of hot water supply here. The default value is 18%.`,
  vacancy_info_paragraph: `If the property was not fully occupied during the entire period, you can enter the vacancy rate in percent here.`,
  vacancy_info_para_1: `Please enter the vacancy rate in % for an entire year and for the entire area.`,
  vacancy_info_para_2: `Calculating the vacancy rate You add up the vacancy rate over the months and divide this by 12. Then multiply the value by 100 and you get the percentage.`,
  vacancy_info_para_3: `Example If the property was vacant for 3 months in 12 months, this would be 25%. Calculation: 3 / 12 * 100 = 25%`,
  heating_system_installed_on1: `Year the `,
  heating_system_installed_on2: `heating system was installed on`,
  heating_system_installed_on_error: `Year must be between 1903 and 2024`,
  heating_system_installed_on_paragraph: `The year of manufacture of the heating system can be found in the exhaust gas measurement report, in the operating instructions, on the type plate, in the acceptance report, etc. If you use district heating, please state the year of manufacture of the district heating transfer station. If your boiler has been modernized, please state the year of modernization. The year the burner was modernized is not relevant. If you have several devices, please state the predominant year of manufacture.`,
  type_of_ventilation: `Type of ventilation`,
  type_of_ventilation_paragraph: `How is the building ventilated? Examples of ventilation systems without heat recovery are exhaust air systems in rooms without windows, such as bathrooms. Ventilation systems with heat recovery include, for example, central or decentralized supply and exhaust air systems that are equipped with heat exchangers.`,
  exhaust_air_system: `Exhaust air system`,
  without_heat_recovery: `Ventilation system without heat recovery`,
  with_heat_recovery: `Ventilation system with heat recovery`,
  shaft_ventilation: `Shaft ventilation`,
  windows_ventilation: `Windows ventilation`,
  living_space: `Living space (not building area)`,
  living_space_error: `Please enter a valid living space (positive number).`,
  living_space_paragraph: `The energy certificate is always linked to the respective building. We therefore ask you to state the living space of the entire building (excluding the basement) in square meters. Based on this information, the usable area of ​​the building is automatically calculated in the energy certificate.`,
  insulation_regulation_met: `Was the 1977 thermal insulation regulation met?`,
  thermal_heading:
    "Please check whether the building meets the 1977 thermal insulation standard . The criteria are met if your building:",
  thermal_point1:
    "1. Has predominantly external walls that are made of either 24 cm thick pumice stone, aerated concrete, block stones, 38 cm sand-lime brick with at least 6 cm insulation or double-shell masonry with 8 cm insulation.",
  thermal_point2:
    "2. Has wooden or plastic windows with double or insulating glazing.",
  thermal_point3:
    "3. Has an insulated roof, with the insulation being either 18 cm on the rafters, 15 cm between the rafters or 8 cm in the attic.",
  thermal_point4:
    "4. If the basement is unheated, the basement ceiling is 5.5 cm thickly insulated (no insulation is required for heated basements or those without a basement).",
  thermal_point5:
    "If all conditions are met, please select the checkbox. This information will help us to correctly categorize you for a consumption or demand certificate.",
  insulation_regulation_met_paragraph: ``,
  building_part: `Building part`,
  building_part_error: `Please select a building part.`,
  building_part_para_1: `In the local sense, a building is only considered a mixed building if two separate energy certificates have to be issued. This is the case if the commercial and residential areas are in a closer ratio than 90% and 10% to each other. In all other cases, "residential building" must be selected.`,
  building_part_para_2: `Furthermore, a joint energy certificate can be issued if the heating system does not differ significantly.`,
  building_part_para_3: `We do not currently issue energy certificates for non-residential buildings.`,
  property_have_basement: `Does property have basement?`,
  lies_below_ground_floor: `What lies below the ground floor?`,
  unheated_basement: `Unheated basement`,
  heated_cellar: `Heated cellar`,
  no_floor_slab: `No basement available/ floor slab`,
  renewables_energy_used: `Are renewables energy used?`,
  do_you_use: `What do you use?`,
  solar_theramal_energy: `Solar thermal energy`,
  photovoltaics: `Photovoltaics`,
  heat_pump: `Heat pump`,
  biomass: `Biomass`,
  renewables_energy_used_for: `What are renewables energy used for?`,
  heating: `Heating`,
  hotwater: `Hotwater`,
  electricity: `Electricity`,
  optional_information_about_equipment: `Would you like to provide optional information about the equipment?`,
  sun_protection: `Which sun protection is available?`,
  sun_protection_error: `Please select a sun protection option.`,
  glare_protection: `No sun/glare protection`,
  flare_protection: `Sun and/or flare protection (roller shutters, blinds), automatically operated`,
  only_glare_protection: `Only glare protection (mostly in office building)`,
  light_directing: `Only glare protection, light-directing (mostly in office buildings)`,
  insulation_glazing: `Does the property have thermal insulation/insulation glazing?`,
  attic_insulation: `Is there roof or attic insulation?`,
  house_number: `Street and house number`,
  house_number_error: `Street is required`,
  house_number_para_1: `Please enter the address of the building for which the energy certificate is to be created.`,
  house_number_para_2: `You can enter the billing and delivery address in the next step.`,
  postcode: `Postcode`,
  postcode_error: `Postcode is required`,
  postcode_para_1: `Please enter the address of the building for which the energy certificate is to be created.`,
  postcode_para_2: `You can enter the billing and delivery address in the next step.`,
  location: `Location`,
  location_error: `Location is required`,
  location_para_1: `Please enter the address of the building for which the energy certificate is to be created.`,
  location_para_2: `You can enter the billing and delivery address in the next step.`,
  upload_building_photo: `Upload building Photo`,
  upload_building_photo_error: `Please upload a valid image file (JPG, PNG, GIF, WEBP).`,
  upload_building_photo_max_size_error: `This image is too big. It must be 10 MB or less.`,
  drag_drop_upload: `Drag & Drop or Upload`,
  energy_certificate_available: `Your Energy Certificate is Available Now`,
  energy_certificate_available_para_1: `Here is your simplified sample copy with your data. Please note that this is not the original ID card. You will receive the original after we review your order.`,
  energy_certificate_available_para_2: `Please review all the data again and then click `,
  energy_certificate_available_box_1: `GEG-compliant · Valid for 10 years`,
  energy_certificate_available_box_2: `Certified energy consultants`,
  energy_certificate_available_box_3: `Immediate delivery: PDF & invoice`,
  energy_certificate_available_box_4: `Secure payment`,
  energy_certificate_available_box_5: `GREENOX GmbH`,
  energy_certificate_available_pdf_check_your_details: `Please check your details. After payment is completed, you will receive your signed and officially registered energy performance certificate including a QR code.`,
  energy_certificate_available_pdf_progress_bar: `95% complete – only 1 step left`,
  energy_certificate_available_pdf_sidebar_section_1_title: `This is what you get with your purchase`,
  energy_certificate_available_pdf_sidebar_section_1_check_1: `✅ Official energy certificate (PDF) with QR code`,
  energy_certificate_available_pdf_sidebar_section_1_check_2: `✅ Manual testing by certified energy consultants`,
  energy_certificate_available_pdf_sidebar_section_1_check_3: `✅ Invoice & Proof for Authorities`,
  energy_certificate_available_pdf_sidebar_section_1_check_4: `✅ Storage & free correction if necessary`,
  energy_certificate_available_pdf_sidebar_section_2_title: `Does your energy consumption seem too high?`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_1: `Don't worry – that's often the case. The calculation uses realistic average values according to GEG.`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_2: `We manually check each ID card`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_3: `before it is registered.`,
  energy_certificate_available_pdf_sidebar_section_2_info: `For old buildings without renovations, values above 150 kWh/m² p.a. are normal. Year of construction, heating and insulation have a strong influence on the characteristic value.`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_1: `The calculated value seems realistic to me`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_2: `I think the value is too high – please check it`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_3: `I would like feedback before the final exhibition`,
  energy_certificate_available_pdf_sidebar_section_2_feedback: `Your Suggestions (optional)`,
  i_reviewed_entries: `I have reviewed my entries and found no errors.
All additional notes have been entered under “Comments & Documents” so they can be considered during processing.
I reviewed my entries and energy values and found no errors.`,
  order_type: `Order type`,
  order_type_paragaraph: `Please select whether you are submitting the application as a private individual or as a company. If you are ordering as a business person with a VAT ID, select 'Business'. If you are ordering as a business person without a VAT ID, select either 'Private' or 'Commercial without VAT ID'.`,
  private_owners: `Private owners`,
  commercial: `Commercial`,
  commercial_ustId: `Commercial (excluding USt.ID)`,
  phone_number: `Phone number`,
  first_name: `First name`,
  surname: `Surname`,
  billing_house_number: `Street & house number`,
  billing_house_number_para_1: `Please enter the address that should appear on the invoice. If you choose the optional postal delivery, we will also send your energy certificate to this address.`,
  billing_house_number_para_2: `If you need different addresses for shipping and the invoice, please enter the additional address in the comments field or contact our customer service directly.`,
  billing_house_number_para_3: `If your address is abroad, you can also enter a foreign address. We also ship abroad.`,
  company_name: `Company name`,
  VAT_ID: `VAT ID`,
  common_error: `this field cannot be empty.`,
  add_on_services: `Add on services`,
  certificate_packages_title: `Certificate Packages`,
  certificate_packages_description: `Purchase multiple certificates in advance and save!`,
  postal_dispatch_invoices: `High-quality postal dispatch of ID cards and invoices`,
  express_exhibition_today: `Express exhibition today`,
  advanced_verification: `Advanced verification (Recommended)`,
  free_correction_option: `Free correction option if incorrect information is detected`,
  experts_explain: `We answer your questions - experts explain!`,
  delivery_method: `Delivery method of ID card (Delivery method of ID card)`,
  delivery_method_2: `Delivery method of ID card (Printed copy by mail and digitally by e-mail)`,
  order_summary: `Order summary`,
  energy_performance_certificate: `Energy Performance Certificate`,
  certificate_residential_build: `Consumption Certificate for Residential Buildings`,
  i_agree_text: `I agree to the terms and conditions and have has taken note of the provisions on data protection and cancellation policy`,
  terms_conditions: `Terms & conditions`,
  total: `Total`,
  order_now: `Order Now`,
  cooling_system: `Is there a cooling system?`,
  save_changes: "Save changes",
  invalid_postal_code: "Invalid postal code",
  invalid_year_of_construction_error:
    "Invalid year, please enter a numeric value.",
  invalid_contain: "should not contain '-', 'e','0', or '+'.",
  invalid_vatId: "not a valid vat id",
  energy_required: "Energy source is required.",
  unitId_required: "Unit ID is required.",
  invalid_consum:
    "Consumption field is invalid. It must be a non-negative number and should not contain 'e', '-', or '+'.",
  year_val: "Year must be between",
  and: "and",
  pos_number: "Please enter a valid living space (positive number).",
  building_part: "Please select a building part.",
  sun_prot: "Please select a sun protection option.",
  street_error: "Street is required",
  post_val: "Postcode must be between 3 to 5 digits",
  con_info: "Consumption info must be a non-empty array.",
  per_pos: "Percentage must be a positive number.",
  less_great: "Value should not be less than 25% or greater than 175% of",
  i_e: "i.e the value in first consumption field.",
  select_error: "Please select number of heating systems installed",
  Occasion_head: "Occasion",

  Occasion_desc: `If you need the energy certificate for financing or a loan application, please select the reason for issue as "Other". Energy certificates with the reasons for issue as "New construction" or "Modernization" cannot be ordered according to Section 80 Sentences 1 and 2 GEG.`,
  build_head: "Building Type",
  build_desc: `For mixed-use buildings, we recommend a demand certificate as this provides more accurate results.`,
  num_aprt: "Number Of Apartments",
  num_aprtdesc: `Since energy certificates can only be issued for the entire building and not for individual apartments, information on all apartments in the building is required. Please count granny flats as separate residential units. For single-family homes, if there are no other apartments in the building, please select 1 residential unit.`,
  num_floor: "Number Of Floors",
  num_floor_desc:
    "Basements and floors with sloped ceilings are not included in the count and are queried separately",
  email: "E-Mail",
  e_para_1: `Please provide a valid email address so that we can contact you if we have any questions regarding your information.`,
  e_para_2: `You will also receive the order confirmation and invoice via the email address you provided.`,
  floor_ceiling: "Floor To Ceiling Height",
  floor_ceiling_desc:
    "The floor height is the distance from the surface of one floor to the surface of the floor above, including the ceiling thickness. If the height is not 250cm, please change it",
  Energy_h: "Energy Source",
  Energy_d: "Please select your main energy source here",
  date_h: "Date",
  date_d: `To apply for a consumption certificate, consumption values ​​from the last three years must be available - that is, the first billing period must be at least three years ago. Enter the month and year of the start of the first billing period here `,
  date_d2: `To apply for a consumption certificate, consumption values ​​from the last two years must be available - that is, the second billing period must be at least two years ago. Enter the month and year of the start of the second billing period here `,
  date_d3: `To apply for a consumption certificate, consumption values ​​from the last one years must be available - that is, the third billing period must be at least one years ago. Enter the month and year of the start of the third billing period here  `,
  date_d4: `To apply for a consumption certificate, consumption values ​​from the last three years must be available - that is, the forth billing period must be at least three years ago. Enter the month and year of the start of the forth billing period here `,

  consmCount_h: "Consumption",
  consmCount_d1: `Please enter the total energy consumption for each period here. A billing period is always one year long.`,
  consmCount_d2: `For apartment buildings, you should state the total energy consumption of the entire building, as energy certificates always refer to the entire building.`,
  consmCount_d3: `If it is a combined heat and power plant (CHP), please only state the amount of heat produced (without electricity).`,
  unit_h: "Unit",
  unit_d1: `Please enter the correct consumption unit of the energy source/fuel.`,
  unit_d2: `You can usually find this on your heating bill.`,
  include_h: "Is Hot Water Included In Heating System",
  include_d: `Please indicate here whether the hot water energy consumption is already included in the consumption stated above or not. You can also specify the hot water energy consumption separately.`,
  system_h: "Is Hot Water Included In Heating System",
  system_d: `Enter the share of hot water supply here. The default value is 18%.`,
  vacancy_h: "Vacancy Percentage",
  vacancy_d1: `Please enter the vacancy rate in % for an entire year and for the entire area.`,
  vacancy_d2: `Calculating the vacancy rate You add up the vacancy rate over the months and divide this by 12. Then multiply the value by 100 and you get the percentage.`,
  vacancy_d3: `Example If the property was vacant for 3 months in 12 months, this would be 25%. Calculation: 3 / 12 * 100 = 25%`,
  install_h: "Year Of Construction Of The Heating System",
  install_d: `You can find the year of installation on the type plate, in the emission test report, user manual, or commissioning documents.
•	For district heating, enter the year of the transfer station installation.
•	If your boiler was modernized, enter the year of the boiler modernization (the burner’s year is not relevant).
•	If you have multiple systems, enter the dominant installation year – meaning the most-used or main system.
`,
  ventilation_h: "Type Of Ventilation",
  ventilation_d: `How is the building ventilated? Examples of ventilation systems without heat recovery are exhaust air systems in rooms without windows, such as bathrooms. Ventilation systems with heat recovery include, for example, central or decentralized supply and exhaust air systems that are equipped with heat exchangers.`,
  livingSpace_h: "Living Area (not total building area)",
  livingSpace_d: `Please enter the total living area of the building in square meters (m²) – excluding basement areas.
The energy certificate always refers to the entire building.
The usable area will be calculated automatically based on this entry.
`,
  building_h: "Building Part",
  building_d1: `In the local sense, a building is only considered a mixed building if two separate energy certificates have to be issued. This is the case if the commercial and residential areas are in a closer ratio than 90% and 10% to each other. In all other cases, "residential building" must be selected.`,
  building_d2: `Furthermore, a joint energy certificate can be issued if the heating system does not differ significantly.`,
  building_d3: `We do not currently issue energy certificates for non-residential buildings.`,
  thermal_h: "Was The 1977 Thermal Insulation Regulation Met?",
  number_h: "Street Or House Number",
  number_d1: `Please enter the address of the building for which the energy certificate is to be created.`,
  number_d2: `You can enter the billing and delivery address in the next step.`,
  Postcode_h: "Postcode",
  Postcode_d1: `Please enter the address of the building for which the energy certificate is to be created.`,
  Postcode_d2: `You can enter the billing and delivery address in the next step.`,
  Location_h: "Location",
  Location_d1: `Please enter the address of the building for which the energy certificate is to be created.`,
  Location_d2: `You can enter the billing and delivery address in the next step.`,
  order_h: "Order Type",
  order_d: `Please choose whether you are applying as a private individual or a business:
•	Private: You are a private person or business without a VAT ID.
•	Business: You are a company with a valid VAT ID number.
•	Business without VAT ID: You operate commercially but do not have a VAT ID (e.g. small business).
This selection is important for correct invoice processing.
`,
  address_d1: `Please enter the address that should appear on the invoice. If you choose the optional postal delivery, we will also send your energy certificate to this address.`,
  address_d2: `If you need different addresses for shipping and the invoice, please enter the additional address in the comments field or contact our customer service directly.`,
  address_d3: `If your address is abroad, you can also enter a foreign address. We also ship abroad.`,
  close_btn: "Close",
  continue: "Continue.",
  prolonged: "Was there a prolonged vacancy?",
  including: "incl. 19% MwSt.",
  energy_certificate_needed:
    'According to your information, an energy requirement certificate is required for your building. However, if you have renovated the building in accordance with the thermal insulation regulations, you also have the option of applying for an energy consumption certificate. To do this, please select the appropriate option "Building renovation present".',
  needed_info: "(Your inputs will be transferred)",
  needed_certificate_button: "Create a need certificate",
  thermal_checkbox:
    "The property complies with the Thermal Insulation Ordinance of 1977",
  notes_documents_button: "Notes & Documents",
  total: "Total",
  order_summary: "Order Summary",
  energy_performance_text: "Energy Performance Certificate",
  i_agree_text:
    "I agree to the terms and conditions and have has taken note of the provisions on data protection and cancellation policy",
  mail_sent: "link sent to your email",
  not_valid_num: "not a valid phone number",
  cannot_be_empty: "this field cannot be empty",
  field_required: "This field is required",
  consum_residential_buildings:
    "Consumption Certificate for Residential Buildings",
  privacy_policy: "Privacy Policy",
  aggree: "I accept the  ",
  proceed: "Please accept the Privacy Policy to proceed",
  notes: "Notes",
  send_mail:
    "We will send a link to your email address that will allow you to continue exactly where you left off.",
  additional_document: "Additional Documents",
  document_additional_text:
    "Here you have the opportunity to upload additional documents that may be helpful for the creation of the energy certificate.",
  document_secondary_text:
    "Since the structure of the building is non-standard, it is recommended to upload all the structure details and building photos (if blueprints are not available)",
  document_info:
    "Any additional information that will help for energy certificate creation can be added here.",
  before_you_go: "Before you go…",
  send_by_mail: "Send link by email:",
  send_mail_desc:
    "We will send a link to your email address that will allow you to continue exactly where you left off.",
  send_link: "Send link",
  cancel: "Cancel",
  submit_details: "Submit details",
  company_name: "Company name",
  vat_id: "VAT ID",
  to: "to",
  sqm: "m²",
  not_found: "Page not found",
  something_wrong: `Something went wrong.<br/>
Please try again after sometime.`,
  support: "If the issue persists, please contact support",
  back_step: "Back to Step 1",
  partially_heated: "Is a floor only partially heated?",

  year: "",
  link_head: "Having trouble uploading files?",
  link_para:
    "If you have difficulty uploading your files or your documents are so large that you would like to send us a link to a cloud service (such as Dropbox, Google Drive, OneDrive), nothing stops you. Just add the link below and share access with `info@greenox-group.de` email ID.",
  year_of_construction: "Year Of Construction",
  year_of_construction_paragraph: `Please indicate the original year the property was built.`,
  below_ground: `What lies below the ground floor? `,
  below_ground_info1: `Please indicate whether there is a basement or whether it is heated. Heated here means that there are radiators in most of the rooms. It does not matter whether you turn them on or not.`,
  below_ground_info2: `If only the boiler room is indirectly heated, this does not count as a heated basement.`,
  cooling_s: `Does the building have a cooling system?`,
  cooling_s_info: `Please indicate whether your property is actively cooled in summer, for example using an air conditioning unit or central cooling system.
This information is important for the building’s overall energy assessment.
`,
  ellusion: "Is there roof or attic insulation?",
  ellusion_info:
    `Please select whether your roof or attic is insulated (Yes or No).
This is an important factor for energy efficiency.
If yes, you will be asked to enter the insulation thickness in cm in the next step.
`,
  build_photo: `Building Photo`,
  build_photo_info: `Please upload a recent photo of the building's exterior (preferably a front view).
This photo will appear on the energy certificate and helps with building identification.
Accepted formats: JPG, PNG, PDF
Maximum file size: 10 MB
👉 Tip: Ensure the building is clearly visible without obstructions (e.g. no parked cars in front).
`,
  email_start: `By proceeding further, you accept our`,
  height_val: `The maximum height must be less than or equal to 5.`,
  payment_done: "Payment done",
  central_distribution: "Central distribution",
  apartment_wise: "Apartment-wise distribution",
  decentralized_distribution: "Decentralized Distribution",
  sub_total: "Sub Total",
  total: "Total",
  discount: "Coupon Discount",
  copon_codes: "Coupon Codes",
  off: "Off",
  apply: "Apply",
  applied: "Applied",
  not_exist: "Invalid coupon code",
  select_option: "Please select atleast one option",
  required_field_error: `This field is required`,
  number_of_air_conditioning_systems: "Number of air conditioning systems requiring inspection",
  cooling_capacity: "Cooling capacity",
  next_inspection_date: "Next Inspection date"


};

export const needCertificateEngText = {
  step_1: "Step 1",
  step_2: "Step 2",
  step_3: "Step 3",
  step_4: "Step 4",
  step_5: "Step 5",
  step_6: "Step 6",
  step_7: "Step 7",
  step_8: "Step 8",
  building_info: "Building Info",
  structure_details: `Structure Details`,
  building_component: `Building Component`,
  heat_generator_details: `Heat Generator details`,
  Please_provide_proper_information: "Please provide proper information",
  property_address: "Property Address",
  file_upload: `File Upload`,
  certificate: "Certificate",
  billing_delivery_address: "Billing & Delivery Address",
  building_data: "Building Data",
  provided_information: "Provided information",
  occasion: "Occasion",
  occasion_error: `Occasion is required`,
  occasion_paragraph: `If you need the energy certificate for financing or a loan application, please select the reason for issue as "Other". Energy certificates with the reasons for issue as "New construction" or "Modernization" cannot be ordered according to Section 80 Sentences 1 and 2 GEG.`,
  postal_code: "Postal Code",
  postal_code_error: `Invalid postal code`,
  building_type: `Building Type`,
  building_type_error: `Building Type is required`,
  building_type_paragraph: `For mixed-use buildings, we recommend a demand certificate as this provides more accurate results.`,
  number_of_apartments: `Number Of Apartments`,
  number_of_apartments_error: "required as a number.",
  field_required_error: "This field is required as a number.",
  number_of_apartments_paragraph: `Since energy certificates can only be issued for the entire building and not for individual apartments, information on all apartments in the building is required. Please count granny flats as separate residential units. For single-family homes, if there are no other apartments in the building, please select 1 residential unit.`,
  year_of_construction: "Year Of Construction",
  year_of_construction_error: `Year must be between 1850 and 2024.`,
  year_of_construction_paragraph: `Please indicate the original year the property was built.`,
  no_of_floors: `No. Of Floors`,
  eMail: `E-Mail`,
  eMail_error: `Invalid email address`,
  eMail_para_1:
    "Please provide a valid email address so that we can contact you if we have any questions regarding your information.",
  eMail_para_2:
    "You will also receive the order confirmation and invoice via the email address you provided.",
  number_of_floors: "Number Of Floors",
  number_of_floors_error: "The Number of floors is required as a number.",
  number_of_floors_paragraph: ``,
  heated_area_floor: `Percentage Heated Area In`,
  provide_your_proper_information: `Provide your proper information.`,
  structure_details_para: `To accurately determine the property's energy requirements, we need the following information from you.`,
  structure_details_para_note: `Please provide only the shape and external dimensions of your building section.`,
  wall_length: `Wall length`,
  corners: `Corners`,
  custom: `Custom`,
  total_floor_height: `Average total floor height (incl. ceiling)`,
  living_space: `Living space`,
  construction_type: `Construction type`,
  material_used: `Material used`,
  part_the_building: `Part of the building`,
  type_of_ventilation: `Type of ventilation`,
  exhaust_air_system: `Exhaust air system`,
  without_heat_recovery: `Ventilation system without heat recovery`,
  with_heat_recovery: `Ventilation system with heat recovery`,
  shaft_ventilation: `Shaft ventilation`,
  windows_ventilation: `Windows ventilation`,
  cooling_system: `Is there a cooling system?`,
  yes: "Yes",
  no: "No",
  from_electricity: `From electricity`,
  delivered_cold: `Delivered cold`,
  passive_cooling: `Passive cooling`,
  cooling_from_heat: `Cooling from heat`,
  has_leaks_been_conducted: `Has a test for leaks been conducted (Blower Door Test)?`,
  compliance_with_tightness: `Compliance with tightness`,
  without_leak_test: `Without leak test`,
  obvious_leaks: `Obvious leaks`,
  other: `Other`,
  required_field_error: `This field is required`,
  roof: `Roof`,
  building_component_error: `Please enter details in Window, Basement, Insulation section`,
  roof_shape: `Roof shape`,
  flat_roof: `Flat roof`,
  gable_roof: `Gable roof`,
  hip_roof: `Hip roof`,
  pult_roof: `Pult roof`,
  walm_flat: `Walm + flat`,
  structure: `Structure`,
  attic: `Attic`,
  attic_type: `Attic type`,
  attic_height: `Attic height`,
  roof_pitch: `Roof pitch`,
  ridge_length: `Ridge length`,
  ridge_width: `Ridge width`,
  is_there_second_attic: `Is there second attic`,
  is_there_second_attic_heated: `Is there second attic heated`,
  second_attic_height: `Second attic height`,
  knee_wall_or_sill: `Does property have a knee wall or sill?`,
  knee_wall_sill_height: `Knee wall / sill height`,
  window: `Window`,
  window_top_para_1: `If you have all the dimensions of all windows, it is recommended that you enter them all to provide accurate energy need information.`,
  have_dimensions_window: `Do you have dimensions of each window?`,
  windows_in_wall: `Please enter all windows in the wall  `,
  window_top_para_2: `Please enter all the windows in all the walls. You can add more windows using the plus icon (+) below. Make sure you enter windows in each wall separately.`,
  window_top_para_3: `Since you do not have dimensions for all the windows, you can use the approximate percentage of the wall occupied by windows. Please try to provide the information as accurate as possible.`,
  wall: `Wall`,
  window_type: `Window type`,
  window_area_wall: `Percentage of window area on the wall`,
  type: `Type`,
  length: `Length`,
  width: `Width`,
  count: `Count`,
  basement: `Basement`,
  below_ground_floor: `What lies below the ground floor?`,
  floor_slab: `Floor slab`,
  Insulation: `Insulation`,
  property_insulated: `Is the property insulated?`,
  exterior_walls: `Exterior walls`,
  roof_or_top_ceiling: `Roof or top ceiling`,
  floor_basement: `Floor / basement`,
  basement_walls: `Basement walls`,
  heating_system_installed: `How many heating system are installed?`,
  energy_source: `Energy source`,
  heating_system: `Heating system`,
  year_1st_heating_installed: `Year of 1st heating system was installed`,
  year_2nd_heating_installed: `Year of 2nd heating system was installed`,
  year_3rd_heating_installed: `Year of 3rd heating system was installed`,
  year_4th_heating_installed: `Year of 4th heating system was installed`,
  distribution_heating: `Distribution heating`,
  share_heating: `Share of heating`,
  hot_water_system_installed: `How many hot water system are installed?`,
  water_heating: `Water heating`,
  year_1st_water_installed: `Year of 1st hot water system was installed`,
  year_2nd_water_installed: `Year of 2nd hot water system was installed`,
  year_3rd_water_installed: `Year of 3rd hot water system was installed`,
  year_4th_water_installed: `Year of 4th hot water system was installed`,
  renewable_energy: `Are renewable energy used?`,
  unheated_basement: `Unheated basement`,
  heated_cellar: `Heated cellar`,
  no_basement: "No basement",
  photovoltaics: `Photovoltaics`,
  heat_pump: `Heat pump`,
  biomass: `Biomass`,
  house_number: `Street and house number`,
  location: `Location`,
  postcode: `Postcode`,
  billing_house_number_para_1: `Please enter the address that should appear on the invoice. If you choose the optional postal delivery, we will also send your energy certificate to this address.`,
  billing_house_number_para_2: `If you need different addresses for shipping and the invoice, please enter the additional address in the comments field or contact our customer service directly.`,
  billing_house_number_para_3: `If your address is abroad, you can also enter a foreign address. We also ship abroad.`,
  direction_object_point: `In which cardinal direction does side A of the object point? `,
  property_another_house: `Is the property next to another house?`,
  title_file_upload: `Information On File Upload`,
  description_file_upload: `Since May 2021, the Building Energy Act (GEG) requires detailed images of the renovation status, building envelope, and system technology (such as heat generators) to be submitted. However, only the image of the building is shown on the energy certificate.`,
  photo_heater: `Photo of the heater`,
  photo_building: `Photo of the Building`,
  energy_certificate_available: `Your Energy Certificate is Available Now`,
  energy_certificate_available_para_1: `Here is your simplified sample copy with your data. Please note that this is not the original ID card. You will receive the original after we review your order.`,
  energy_certificate_available_para_2: `Please review all the data again and then click `,
  energy_certificate_available_para_3: `The values ​​were calculated using an approximate method. Please note that this is not the final energy certificate. You will receive the registered and legally valid energy certificate after we have checked your information.`,
  energy_certificate_available_box_1: `GEG-compliant · Valid for 10 years`,
  energy_certificate_available_box_2: `Certified energy consultants`,
  energy_certificate_available_box_3: `Immediate delivery: PDF & invoice`,
  energy_certificate_available_box_4: `Secure payment`,
  energy_certificate_available_box_5: `GREENOX GmbH`,
  energy_certificate_available_pdf_check_your_details: `Please check your details. After payment is completed, you will receive your signed and officially registered energy performance certificate including a QR code.`,
  energy_certificate_available_pdf_progress_bar: `95% complete – only 1 step left`,
  energy_certificate_available_pdf_sidebar_section_1_title: `This is what you get with your purchase`,
  energy_certificate_available_pdf_sidebar_section_1_check_1: `✅ Official energy certificate (PDF) with QR code`,
  energy_certificate_available_pdf_sidebar_section_1_check_2: `✅ Manual testing by certified energy consultants`,
  energy_certificate_available_pdf_sidebar_section_1_check_3: `✅ Invoice & Proof for Authorities`,
  energy_certificate_available_pdf_sidebar_section_1_check_4: `✅ Storage & free correction if necessary`,
  energy_certificate_available_pdf_sidebar_section_2_title: `Does your energy consumption seem too high?`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_1: `Don't worry – that's often the case. The calculation uses realistic average values according to GEG.`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_2: `We manually check each ID card`,
  energy_certificate_available_pdf_sidebar_section_2_para_part_3: `before it is registered.`,
  energy_certificate_available_pdf_sidebar_section_2_info: `For old buildings without renovations, values above 150 kWh/m² p.a. are normal. Year of construction, heating and insulation have a strong influence on the characteristic value.`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_1: `The calculated value seems realistic to me`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_2: `I think the value is too high – please check it`,
  energy_certificate_available_pdf_sidebar_section_2_checkbox_3: `I would like feedback before the final exhibition`,
  energy_certificate_available_pdf_sidebar_section_2_feedback: `Your Suggestions (optional)`,
  i_reviewed_entries: `I reviewed my entries and energy values and found no errors.`,
  order_type: `Order Type`,
  order_type_paragaraph: `Please select whether you are submitting the application as a private individual or as a company. If you are ordering as a business person with a VAT ID, select 'Business'. If you are ordering as a business person without a VAT ID, select either 'Private' or 'Commercial without VAT ID'.`,
  private_owners: `Private Owners`,
  commercial: `Commercial`,
  commercial_ustId: `Commercial (excluding USt.ID)`,
  phone_number: `Phone Number`,
  first_name: `First Name`,
  surname: `Surname`,
  add_on_services: `Add On Services`,
  certificate_packages_title: `Certificate Packages`,
  certificate_packages_description: `Purchase multiple certificates in advance and save!`,
  postal_dispatch_invoices: `High-quality postal dispatch of ID cards and invoices`,
  express_exhibition_today: `Express exhibition today`,
  advanced_verification: `Advanced Verification (Recommended)`,
  free_correction_option: `Free correction option if incorrect information is detected`,
  experts_explain: `We answer your questions - experts explain!`,
  delivery_method: `Delivery Method of ID Card (Delivery Method of ID Card)`,
  delivery_method_2: `Delivery Method of ID Card (Printed copy by mail and digitally by e-mail)`,
  custom_structure: `Custom Structure`,
  note: "note",
  floor: "floor",
  solid_construction: "Solid construction",
  wooden_construction: "Wodden construction",
  pre_fabricated: "Prefabricated house",
  total_building: "Total building",
  residential_part: "Residential part of mixed building",
  solid_ceiling: "Solid ceiling",
  wooden_ceiling: "Wooden ceiling",
  heated_attic: "Heated attic",
  unheated_attic: "Unheated attic",
  heating_percentage: "Percentage of the heated area",
  heated_percentage_second: "Heating percentage of second attic",
  heated_part_basement: "Heated part of basement",
  continue: "Continue.",
  billing_house_number: "Street & House Number",
  construction_year_error: "Year must be between 1850 and",
  invalid_data_error: "This field should not contain '-', 'e', or '+'.",
  field_required: "This field is required",
  invalid_year_of_construction_error:
    "Invalid year, please enter a numeric value.",
  invalid_contain: "should not contain '-', 'e','0', or '+'.",
  not_valid_num: "not a valid phone number",
  image_error: "To ensure that this is the heater described, we need a photo.",

  common_error: `this field cannot be empty.`,
  notes_documents_button: "Notes & Documents",
  save_resume_later: "Save & Resume Later",
  next: `Next`,
  previous: "Previous",
  type: "Type",
  length: "Length",
  width: "Width",
  count: "Count",
  no_of_floor: `Number of floors`,
  no_of_floors_info: `Basements and floors with slopes are not counted and are queried separately`,
  per_first_floor: `Percentage Heated Area In 1st floor`,
  floor: "floor",
  per_first_floor_info: `Please enter the proportion of the heated area on each floor
`,
  avg_height: `Average full storey height (incl. ceiling)  `,
  avg_height_info: `The storey height is the distance from the surface of a floor to the surface of the floor above, i.e. including the ceiling thickness. If the height is not 0.25m (250cm), please change it.`,
  living_sp: `Living space (not building space)`,
  living_sp_info1: `The energy certificate is always linked to the respective building. We therefore ask you to state the living space of the entire building (excluding basement) in square meters.`,
  living_sp_info2: ` Based on this information, the floor space of the building is automatically calculated in the energy performance certificate.`,
  type_con: `Design`,
  type_con_info: `Please indicate the type of construction that applies to your property. If there are different types of construction, please indicate the predominant one.`,
  material: `Building material used`,
  material_info1: `Please specify the type of construction in detail.`,
  material_info2: `If you have additional insulation, you can specify this in the next step. If you cannot select your exterior material from the list or you know the exact U-value, please send us the U-value.`,
  part_of_build: `Part of the building`,
  part_of_build_info: `A building is only considered a mixed building if two separate energy performance certificates have to be issued. This is the case if commercial and residential areas are in a closer ratio than 90 % and 10 %. In all other cases, “residential building” must be selected. Furthermore, a joint energy performance certificate can be issued if the heating system does not differ significantly. We also issue energy performance certificates for non-residential buildings. Please send us an e-mail to info@greenox-group.de`,
  type_ventilation: `Type of ventilation`,
  type_ventilation_info: `How is the building ventilated? Examples of ventilation systems without heat recovery are exhaust air systems in rooms without windows, such as bathrooms. Ventilation systems with heat recovery include, for example, centralized or decentralized supply and exhaust air systems equipped with heat exchangers.`,
  colling: `Is there a cooling system?`,
  colling_info: `Please indicate whether your property is cooled in summer. This can be done via an air conditioning system, for example.`,
  door_test: `Has a test for leaks been carried out (Blower Door Test)?`,
  door_test_info: `Please indicate whether a blower door test was carried out to measure the airtightness`,

  shape: `Roof shape`,
  window_install_year: `Year of construction Windows`,
  shape_info: `Please let us know the roof type of your building. If your building has a different roof type, please select "gabled roof" and provide details about the roof type in the comments section.`,
  structure: `Structure`,
  structure_info: `Please indicate whether your building is solid (not made of wood) or made of wood. Flat roofs are usually solid (not made of wood) and pitched roofs are usually made of wood.`,
  type: `Type`,
  type_info: `Please select the type of glazing and the material of the window frame.`,
  length: `Length (in meters)`,
  length_info: `Please enter the length of the window in meters`,
  width: `Width (in meters)`,
  width_info: `Please enter the width of the window in meters`,
  count: `Number of windows`,
  count_info: `Please enter the number of windows on this wall that have the same length and width`,
  window_type: `Window type`,
  window_type_info: `Please select the type of glazing and the material of the window frame.`,
  per_window: `Percentage of window area in the building envelope`,
  per_window_info: `Specification of the percentage of the window area on the selected wall`,
  under_1st: `What is hidden under the first floor?`,
  under_1st_info1: `Please indicate whether there is a cellar or whether it is heated. Heated here means that there are radiators in the majority of the rooms. It does not matter whether you switch them on or not.`,
  under_1st_info2: `If only the boiler room is indirectly heated, this does not count as a heated cellar.`,
  slab: `Base plate`,
  slab_info: `Please specify the construction method of the floor slab against the ground.`,
  insulated: `Is the property insulated?`,
  ex_walls: `Insulation (exterior walls) - in centimeter`,
  ex_walls_info: `Please indicate whether your exterior walls are insulated. Indicate the average thickness of the insulation WITHOUT the construction layer.`,
  top_roof: `Insulation (roof or top ceiling) - in centimeter`,
  top_roof_info: `Please indicate here whether and to what extent your roof or top floor ceiling (attic) is insulated. If both parts of the building are insulated, please indicate the thicker insulation. Please only indicate the insulation.`,
  celler: `Insulation (floor / cellar) - in centimeter`,
  celler_info1: `Please indicate whether and to what extent your basement ceiling or floor slab is insulated. If both parts of the building are insulated, please indicate the thicker insulation. Please note that you should only enter the insulation.`,
  celler_info2: `If you have impact sound insulation, please let us know this as well.`,
  base_walls: `Insulation (basement walls) - in centimeter`,
  base_walls_info: `Please indicate here whether and to what extent your basement walls are insulated. Please enter the insulation in meters.`,
  source: `Energy source`,
  source_info: `Please select your main energy source here`,
  unit: `Unit`,
  unit_info: `Please enter the correct consumption unit of the energy source/fuel. You will usually find this on your heating bill.`,
  date: `Date`,
  date_info: `To apply for a consumption certificate, consumption values from the last three years must be available - i.e. the first billing period must be at least three years ago. Enter the month and year of the start of the first billing period here`,
  install_h: "Year Of Construction Of The Heating System",
  heating_system_installed_on_paragraph: `The year of manufacture of the heating system can be found in the exhaust gas measurement report, in the operating instructions, on the type plate, in the acceptance report, etc. If you use district heating, please state the year of manufacture of the district heating transfer station. If your boiler has been modernized, please state the year of modernization. The year the burner was modernized is not relevant. If you have several devices, please state the predominant year of manufacture.`,
  number_h: "Street Or House Number",
  number_d1: `Please enter the address of the building for which the energy certificate is to be created.`,
  number_d2: `You can enter the billing and delivery address in the next step.`,
  postcode_para_1: `Please enter the address of the building for which the energy certificate is to be created.`,
  postcode_para_2: `You can enter the billing and delivery address in the next step.`,
  Postcode_h: "Postcode",
  build_photo: `Building Photo`,
  build_photo_info: `If available, you can upload a photo of the building (exterior view). This image will appear on the energy certificate.`,
  order_type: `Order Type`,
  order_type_paragaraph: `Please select whether you are submitting the application as a private individual or as a company. If you are ordering as a business person with a VAT ID, select 'Business'. If you are ordering as a business person without a VAT ID, select either 'Private' or 'Commercial without VAT ID'.`,
  billing_house_number: `Street & House Number`,
  billing_house_number_para_1: `Please enter the address that should appear on the invoice. If you choose the optional postal delivery, we will also send your energy certificate to this address.`,
  billing_house_number_para_2: `If you need different addresses for shipping and the invoice, please enter the additional address in the comments field or contact our customer service directly.`,
  billing_house_number_para_3: `If your address is abroad, you can also enter a foreign address. We also ship abroad.`,

  eMail: `E-Mail`,
  eMail_para_1:
    "Please provide a valid email address so that we can contact you if we have any questions regarding your information.",
  eMail_para_2:
    "You will also receive the order confirmation and invoice via the email address you provided.",
  attic: `Attic`,
  attic_info: `Please state the construction of your attic (top floor ceiling). Most of the time there are wooden beam ceilings. If this is different in your case, please state "solid ceiling".`,
  attic_type: `Attic Type`,
  attic_type_info1: `Please indicate whether your attic is heated either directly or through an air connection. If the attic is only partially heated, please indicate heated.`,
  attic_type_info2: `In this context, the word "attic" refers to the first floor which has sloping ceilings.`,
  roof_p: `Roof Pitch`,
  roof_p_info: `Please indicate the pitch of your roof in degrees. The roof pitch describes the angle that the roof surface forms with the horizontal.`,
  Attic_Height: `Attic Height`,
  Attic_Height_info1: `Enter the height of the attic here. The attic height is the distance between the top edge of the floor and the bottom edge of the roof structure.`,
  Attic_Height_info2: `If you are unsure, please click on "Determine attic height". We will then calculate the attic height for you based on your building details.`,
  Attic_Height_info3: `Please enter the height of the attic. If there is an attic or loft, please only enter the height of the lower level and enter the loft as a 2nd attic floor.`,
  sec_attic: `Is There Second Attic`,
  sec_attic_info: `A 2nd attic is an additional floor located in the attic of a house. It is an extension of the normal attic, which is usually used as living space or as storage space.`,
  sec_attic_heat: `Is There Second Attic Heated`,
  sec_attic_heat_info: `Please indicate whether your attic (smaller attic floor) is heated either directly or through an air connection. If the attic floor is only partially heated, please indicate heated. In this context, the word "attic floor" refers to the highest floor that has sloping ceilings . Other terms would be loft or attic.`,
  sec_attic_per: `Heating percentage of second attic`,
  sec_attic_per_info: `Indicate the percentage of the second attic area (based on attic floor area)`,
  sec_attic_height: `Second Attic Height`,
  sec_attic_height_info: `Please specify the height of the attic above the larger attic floor by measuring the distance from the top of the floor to the highest point of the roof, usually the ridge purlin.`,
  sill: `Does Property Have A Knee Wall Or Sill?`,
  sill_info: `A knee wall is a section of wall that lies between the top floor and the roof of a house. The knee wall is usually located below the top floor and extends to the roof structure. The external wall that touches the air is relevant here. The internal brickwork or similar is not decisive.`,
  sill_height: `Knee Wall / Sill Height`,
  heater_photo: `Photo of the heater`,
  heater_photo_info1: `Please upload photos of your heat generator here.`,
  heater_photo_info2: `You can upload multiple photos.`,
  heater_photo_info3: `The photos should confirm your information in a comprehensible manner. Photos of your heating system and hot water preparation (type plates for the heating AND hot water preparation) are helpful, but also photos of the equipment such as the heating boiler, heating circuit pump, hot water storage, etc.`,
  heater_photo_info4: `Invoices or chimney sweep reports that document your heating/hot water system are also possible.`,
  type_roof: "Roof",
  type_window: "Window",
  type_basement: "Basement",
  type_insulation: "Insulation",
  company_name: `Company Name`,
  VAT_ID: `VAT ID`,
  order_summary: `Order Summary`,
  i_agree_text: `I agree to the terms and conditions and have has taken note of the provisions on data protection and cancellation policy`,
  terms_conditions: `Terms & conditions`,
  privacy_policy: "Privacy Policy",
  total: "Total",
  including: "incl. 19% MwSt.",
  order_now: `Order Now`,
  custom_info:
    "Additional documents such as building plan and sketches will be helpful for our energy consultant to understand your building structure.",
  custom_agree:
    "I agree that an additional charges will be required for this building’s energy certificate as the building does not have a standard structure.",
  add_documents: "Add Documents & Notes",
  sqm: "m²",
  not_found: "Page not found",
  something_wrong: `Something went wrong.<br/>
Please try again after sometime.`,
  support: "If the issue persists, please contact support",
  back_step: "Back to Step 1",
  partially_heated: "Is a floor only partially heated?",
  year: "",
  Documents_notes_btn: "Add Documents & Notes",
  water_system: "How many hot water system are installed?",
  year_of: "Year of construction in which the",
  heating_install: "heating system was installed",
  water_install: "hot water system was installed",
  valid_number: "Not a valid number",
  select_option: "Please select atleast one option",
  link_head: "Having trouble uploading files?",
  link_para:
    "If you have difficulty uploading your files or your documents are so large that you would like to send us a link to a cloud service (such as Dropbox, Google Drive, OneDrive), nothing stops you. Just add the link below and share access with `info@greenox-group.de` email ID.",
  window_year: "Year of construction of the windows",
  wall: `Which wall is against another house?`,
  email_start: `By proceeding further, you accept our`,
  concrete_construction: "Reinforced concrete construction",
  wooden_construction: "Wooden construction",
  other: "other",
  energy_performance_text: "Energy Performance Certificate",
  certificate_residential_build:
    "Consumption Certificate for Residential Buildings",
  aggree: "I accept the  ",
  proceed: "Please accept the Privacy Policy to proceed",
  faq: `Explore our frequently asked questions about our energy certificate system here`,
  percent_error: "The Value must be between 0% and 100%",
  no_wall: "We will get this information out of your provided data",
  height_val: `The maximum height must be less than or equal to 5.`,
  year_val: "Year must be between",
  and: "and",
  payment_done: "Payment done",
  central_distribution: "Central distribution",
  apartment_wise: "Apartment-wise distribution",
  decentralized_distribution: "Decentralized Distribution",
  sub_total: "Sub Total",
  total: "Total",
  discount: "Coupon Discount",
  copon_codes: "Coupon Codes",
  off: "Off",
  apply: "Apply",
  applied: "Applied",
  not_exist: "Invalid coupon code",
  number_of_air_conditioning_systems: "Number of air conditioning systems requiring inspection",
  cooling_capacity: "Cooling capacity",
  next_inspection_date: "Next Inspection date",
  Heating_coverage_rate_in: "Heating coverage rate in %",
  position_of_ventilation: "Position of ventilation System"

};
export const successEngText = {
  heading: `Thank you for ordering`,
  statusText: `Your payment has been successfully received.`,
  status_desc: `We have received your order  and shall get started with the processing.You will receive your final certificate on the email shared by you.`,
  receipt: `Receipt`,
  invoice: `Invoice`,
  order_id: "Order Id",
  receipt: "Receipt",
  invoice: "Invoice",
  sqm: "m²",
};
export const failureEngText = {
  heading: `Payment Failed – Action Required`,
  statusText: `Your payment was not successfully processed.`,
  status_desc: `We have received your order but were unable to process the payment.
Once the payment is successfully processed, we will begin processing your order and 
send the final certificate to the email address you provided.`,
  retry_payment: ` Retry Payment`,
  order_id: "Order Id",
  retry: "Retry payment",
};
